import { LanguageSwitcher } from "@/shared/ui/lang/LanguageSwitcher";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const asset = (p: string) =>
  `${import.meta.env.BASE_URL}${encodeURI(p.replace(/^\/+/, ""))}`;

export default function MaintenancePage() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      {/* Language switcher top-right */}
      <Box
        sx={{
          position: "fixed",
          top: { xs: 12, md: 20 },
          right: { xs: 12, md: 20 },
          zIndex: 10,
        }}
      >
        <LanguageSwitcher />
      </Box>

      {/* Glass card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 760,
          borderRadius: { xs: 4, md: 6 },
          px: { xs: 3, sm: 5, md: 7 },
          py: { xs: 4, sm: 5, md: 6 },

          // glass effect
          backgroundColor: "rgba(255,255,255,0.86)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: "1px solid rgba(255,255,255,0.7)",
          boxShadow: "0 20px 60px rgba(15, 23, 42, 0.18)",

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 2,
        }}
      >
        <Box
          component="img"
          src={asset("logos/png/ATLANTE LOGO v3_inline RGB.png")}
          alt="Atlante"
          sx={{
            height: { xs: 120, sm: 120, md: 96 },
            width: "auto",
            maxWidth: "80vw",
          }}
        />

        <Typography
          sx={{
            color: "#0A0A0A",
            fontWeight: 800,
            fontSize: { xs: "1.55rem", md: "2.1rem" },
            lineHeight: 1.15,
            letterSpacing: "-0.02em",
          }}
        >
          {t("onboarding.maintenance.title")}
        </Typography>

        <Typography
          sx={{
            color: "#4A5568",
            fontSize: { xs: "1rem", md: "1.05rem" },
            lineHeight: 1.6,
            maxWidth: 620,
            mb: 0,
          }}
        >
          {t("onboarding.maintenance.message")}
        </Typography>
      </Box>
    </Box>
  );
}
